import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { forwardRef } from 'react';
import { c as classNames } from '../../../shared/bind-a2a3a613.js';
import { getTestId } from '../../../utils/testId.js';
import { s as styles } from '../../../shared/Input-18ed845e.js';
import { idFromName, computeId } from '../../../utils/html.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var cssClasses = classNames.bind(styles);

/* ---------- String-union sources of truth ---------- */
var INPUT_SELECT_STYLING_VALUES = ['tight', 'narrow', 'wide'];
var INPUT_SELECT_THEME_VALUES = ['primary'];
/* ---------- Back-compat shims (public API) ---------- */
var INPUT_SELECT_STYLING = {
  Tight: 'tight',
  Narrow: 'narrow',
  Wide: 'wide'
};
var INPUT_SELECT_THEME = {
  Primary: 'primary'
};

/* ---------- Type definitions ---------- */

var InputSelectBase = function InputSelectBase(_ref) {
  var name = _ref.name,
    idProp = _ref.id,
    validation = _ref.validation,
    title = _ref.title,
    value = _ref.value,
    placeholder = _ref.placeholder,
    options = _ref.options,
    styling = _ref.styling,
    theme = _ref.theme,
    forwardedRef = _ref.forwardedRef,
    testId = _ref.testId,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    aria = _ref.aria;
  var renderOptions = function renderOptions() {
    return _mapInstanceProperty(options).call(options, function (option) {
      return /*#__PURE__*/jsx("option", {
        value: option.value,
        "data-testid": getTestId(testId, 'option'),
        children: option.label
      }, option.value);
    });
  };
  var baseId = idFromName(name);
  var computedId = computeId(idProp, baseId);
  var inputClass = cssClasses(styles.input, styles.select, styling, theme);
  var AccessibleWrapper = title ? 'label' : 'div';
  return /*#__PURE__*/jsxs(AccessibleWrapper, {
    htmlFor: computedId,
    className: inputClass,
    "data-testid": testId,
    children: [title ? /*#__PURE__*/jsx("div", {
      className: styles.title,
      "data-testid": getTestId(testId, 'title'),
      children: title
    }) : null, /*#__PURE__*/jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/jsxs("select", _objectSpread(_objectSpread({
        className: styles.value,
        name: name,
        value: value === null ? undefined : value,
        id: computedId,
        required: required,
        disabled: disabled,
        onChange: onChange,
        onBlur: onBlur,
        ref: forwardedRef,
        "data-testid": getTestId(testId, 'select')
      }, aria), {}, {
        children: [placeholder ? /*#__PURE__*/jsx("option", {
          value: "",
          disabled: true,
          className: styles.placeholder,
          "data-testid": getTestId(testId, 'placeholder'),
          children: placeholder
        }) : null, renderOptions()]
      }))
    }), validation ? /*#__PURE__*/jsx("div", {
      className: styles.note,
      children: validation
    }) : null]
  });
};

/** The public component type: a React component value that also has deprecated statics */

var InputSelect = InputSelectBase;
var InputSelectWithForwardedRefBase = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(InputSelect, _objectSpread({
    forwardedRef: ref
  }, props));
});
InputSelectWithForwardedRefBase.displayName = InputSelect.name;

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var InputSelectWithForwardedRef = _Object$assign(InputSelectWithForwardedRefBase, {
  /** @deprecated Use string unions, e.g. styling="narrow" */
  Styling: INPUT_SELECT_STYLING,
  /** @deprecated Use string unions, e.g. theme="primary" */
  Theme: INPUT_SELECT_THEME
});

export { INPUT_SELECT_STYLING, INPUT_SELECT_STYLING_VALUES, INPUT_SELECT_THEME, INPUT_SELECT_THEME_VALUES, InputSelectWithForwardedRef, InputSelectWithForwardedRef as default };
//# sourceMappingURL=InputSelect.js.map
